import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getArticleBySlug } from '@/mocks/articles';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items?: BreadcrumbItem[];
  categorySlug?: string;
  articleSlug?: string;
  currentPage?: string;
}

export default function Breadcrumb({ items, categorySlug, articleSlug, currentPage }: BreadcrumbProps) {
  let crumbs: BreadcrumbItem[] = [{ label: '首页', to: '/' }];

  if (items) {
    crumbs = items;
  } else if (categorySlug && articleSlug) {
    const category = categories.find((c) => c.slug === categorySlug);
    const article = getArticleBySlug(articleSlug);
    if (category) crumbs.push({ label: category.name, to: `/category/${categorySlug}` });
    if (article) crumbs.push({ label: article.title });
  } else if (categorySlug) {
    const category = categories.find((c) => c.slug === categorySlug);
    if (category) crumbs.push({ label: category.name });
  } else if (currentPage) {
    crumbs.push({ label: currentPage });
  }

  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {crumbs.map((crumb, index) => (
          <li key={index} className="flex items-center gap-1">
            {index > 0 && (
              <span className="text-foreground-300 mx-1">
                <i className="ri-arrow-right-s-line text-xs"></i>
              </span>
            )}
            {crumb.to ? (
              <Link
                to={crumb.to}
                className="text-foreground-500 hover:text-primary-500 transition-colors duration-200"
              >
                {crumb.label}
              </Link>
            ) : (
              <span className={index === crumbs.length - 1 ? 'text-foreground-800 font-medium' : 'text-foreground-500'}>
                {crumb.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}